import { twMerge } from 'tailwind-merge';
import LoadingIcon from 'src/assets/icons/loader.svg';

const PageLoader = ({
  text = 'LOADING...',
  className,
}: {
  text?: string;
  className?: string;
}) => (
  <div
    role="status"
    aria-live="polite"
    aria-label={text}
    className={twMerge(
      'fixed left-0 top-0 z-50 bg-surface w-screen h-screen flex flex-col items-center justify-center gap-2.5 text-center',
      className
    )}
  >
    <LoadingIcon
      aria-hidden="true"
      className="w-10 h-10 text-secondary-ghost-alt-60 animate-spin"
    />
    <span className="text-xs font-medium text-surface-alt-75">{text}</span>
  </div>
);

export default PageLoader;
